@if (v3() && legend()) {
  <div class="chart-legend">
    <span>Earnings per Share</span>
    <span>in {{ currencySymbol() }} · je Quartal</span>
  </div>
}
<div class="eps-chart" [class.v3]="v3()">
  <div class="chart-area">
    <!-- Grid lines -->
    <div class="grid">
      @for (tick of yAxis(); track tick) {
        <div class="grid-line"></div>
      }
    </div>

    <!-- Bars -->
    <div class="bars">
      @if (v3()) {
        <svg class="lines" viewBox="0 0 100 100" preserveAspectRatio="none">
          @for (seg of lineSegments(); track $index) {
            <line
              [attr.x1]="seg.x1"
              [attr.y1]="seg.y1"
              [attr.x2]="seg.x2"
              [attr.y2]="seg.y2"
              [class.dashed]="seg.dashed"
              vector-effect="non-scaling-stroke"
            />
          }
        </svg>
      }
      @for (q of quarters(); track q.label) {
        <div class="bar-group" [class.upcoming]="q.upcoming" [style.--i]="$index">
          <div class="bar-area">
            @if (!q.upcoming) {
              @if (isComparable(q)) {
                <!-- Delta above actual dot — only when both values exist -->
                <span
                  class="delta-label"
                  [class.beat]="isBeat(q)"
                  [class.miss]="!isBeat(q)"
                  [style.bottom.%]="barHeight(q.actual!)"
                >
                  {{ delta(q) }}
                </span>
                <!-- Expected dot — only when expected exists -->
                <div
                  class="dot expected"
                  [style.bottom.%]="barHeight(q.expected!)"
                  [title]="formatExpected(q.expected!)"
                ></div>
              }
              <!-- Bar -->
              <div
                class="bar"
                [class.beat]="isComparable(q) && isBeat(q)"
                [class.miss]="isComparable(q) && !isBeat(q)"
                [style.height.%]="barHeight(q.actual!)"
              ></div>
              <!-- Actual dot -->
              <div
                class="dot actual"
                [class.beat]="isComparable(q) && isBeat(q)"
                [class.miss]="isComparable(q) && !isBeat(q)"
                [style.bottom.%]="barHeight(q.actual!)"
              ></div>
            } @else {
              @if (q.expected !== null) {
                <div
                  class="dot expected upcoming-dot"
                  [style.bottom.%]="barHeight(q.expected)"
                  [title]="formatExpected(q.expected)"
                ></div>
              }
            }
          </div>

          <div class="bar-label">
            <span class="quarter-label">{{ q.label }}</span>
            @if (!q.upcoming && isComparable(q)) {
              <span class="result-label" [class.beat]="isBeat(q)" [class.miss]="!isBeat(q)">
                {{ isBeat(q) ? 'Beat' : 'Miss' }}
              </span>
            }
            @if (q.upcoming && q.upcomingDate) {
              <span class="date-label">{{ q.upcomingDate }}</span>
            }
          </div>
        </div>
      }
    </div>

    <!-- Y-axis labels -->
    <div class="y-axis">
      <div class="y-ticks">
        @for (tick of yAxis(); track tick) {
          <span class="y-tick">{{ formatTick(tick) }}</span>
        }
      </div>
      <span class="eps-label">EPS</span>
    </div>
  </div>
</div>
